import { AvailableGiftDTO, CouponsV2AvailableGiftDTO, CouponsV2GiftDTOGiftTypeEnum } from 'probonio-shared-ui/api';

/**
 * v2 incentives expose `incentiveOccasion` (with `occasion` often OTHER). v1 incentives only have `occasion`.
 * Same `giftType === INCENTIVE` string for v1/v2; v1 objects never carry `incentiveOccasion`
 */
export function resolveGiftOccasionKey(gift: AvailableGiftDTO | CouponsV2AvailableGiftDTO): string {
  if (gift.giftType === CouponsV2GiftDTOGiftTypeEnum.Incentive) {
    const v2 = gift as CouponsV2AvailableGiftDTO;
    if (v2.incentiveOccasion) {
      return v2.incentiveOccasion;
    }
  }
  return gift.occasion;
}
